import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import LOOKUP from 'constants/lookup';
import { showError, showSnackbar } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
import { clearUnprintedOrders, getOnlineOrder } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { onlineOrdersCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

import DialogInput from 'screens/components/advanced/DialogInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import SearchFields from './searchFields';


const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    width: '180px',
    maxWidth: 'none'
};

const pageName = "OnlineOrderList";

class OnlineOrdersPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 10,
            productListCarroussel: [],
            selectedProductGroup: [],
            dialogProducts: false,
            edit: false,
            loading: false,
            dialogClearUnprintedOrders: false
        }
        this.getUnprintedOrdersInterval = null;
        this.refreshPageInterval = null;
        this.getUnPrintedOrders = this.getUnPrintedOrders.bind(this);
        this.ws = null;
    }

    componentWillMount() {
        try {
            this.initWebSocket();
        } catch (err) {
            console.log(`WebSocket Error: ${err}`);
            this.initWebSocket();
        }
    }

    componentDidMount() {
        this.getAllOnlineOrders();
        this.props.clearFormInput("OnlineOrderListOrderCode");
        this.refreshPageInterval = setInterval(() => {
            this.getAllOnlineOrders();
        }, 1000 * 60);
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    componentWillUnmount() {
        clearInterval(this.getUnprintedOrdersInterval);
        clearInterval(this.refreshPageInterval);
    }

    getAllOnlineOrders = () => {
        this.props.getOnlineOrder({
            branchId: this.props.branchId,
            activePage: 1,
            itemsPerPage: 10,
            orderCode: 0,
            onlineOrderStatus: this.props.onlineOrderStatus,
            onlineOrderType: this.props.onlineOrderType,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            phone: this.props.phone,
            email: this.props.email,
            beginDate: this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : "",
            endDate: this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : ""
        });
    }

    saveSuccess = () => {
        this.props.showSuccess(LOOKUP.ecommerce.onlineOrders.messages.savedMessage);
    }

    saveFailure = () => {
        this.props.showError(LOOKUP.ecommerce.onlineOrders.messages.saveErrorMessage);
    }

    closeDialog = () => {
        this.setState({ dialogConfirmCloseRegister: false });
    }

    showOnlineOrder = (id) => {
        this.props.navigate("/ecommerce/online-orders/details/" + id);
    }

    getUnPrintedOrders = () => {
        if ((this.ws && this.ws.readyState === WebSocket.OPEN) || this.props.padVersion) {
            clearInterval(this.refreshPageInterval);
            this.setState({
                loading: true
            });
            this.getUnprintedOrdersInterval = setInterval(() => {
                fetch(`${this.props.store.apiUrl}unauthorized/getUnPrintedOrders/${this.props.branchId}`, {
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                    .then(res => res.json())
                    .then((result) => {
                        if (result.data && result.data.id && (result.data.code > 0 || result.data.buddiNumber > 0)) {
                            console.log("start printing order...");
                            console.log(result.data);
                            this.printingService(result.data);
                        } else {
                            console.log("no order to be printed!");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }, 1000 * this.props.printingServerInterval);
        } else {
            clearInterval(this.getUnprintedOrdersInterval);
            this.props.showError("Can not start detect new order, please make sure there is only one TechPOS tab in your browser, close all other tabs and refresh this page and try again. If the issue still not resolved, please contact our support.");
        }
    }

    printOrder = (id) => {
        if ((this.ws && this.ws.readyState === WebSocket.OPEN) || this.props.padVersion) {
            fetch(`${this.props.store.apiUrl}unauthorized/onlineOrderDetails/${id}`, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then((result) => {
                    if (result.data && result.data.id && (result.data.code > 0 || result.data.buddiNumber > 0)) {
                        console.log("start printing order...");
                        console.log(result.data);
                        this.printingService(result.data);
                    } else {
                        console.log("no order to be printed!");
                    }
                })
                .catch((err) => {
                    console.log(err);
                })

        } else {
            this.props.showError("Can not start print order, please make sure there is only one TechPOS tab in your browser, close all other tabs and refresh this page and try again. If the issue still not resolved, please contact our support.");
        }
    }

    printingService = (oneEx) => {
        let data = {
            OrderId: oneEx.id,
            OnlineOrderCode: oneEx.buddiNumber === null ? oneEx.code : oneEx.buddiNumber,
            GeneratedOrderId: oneEx.generatedOrderId,
            IsBuddiOrder: oneEx.buddiNumber === null ? false : true,
            OrderType: oneEx.type == 1 ? "Online Order" : oneEx.type == 2 ? "Express Checkout" : "Fulfillment Order",
            CustomerName: oneEx.member,
            Address: oneEx.address,
            AddressTwo: oneEx.addressTwo,
            City: oneEx.city,
            Phone: oneEx.phone,
            State: oneEx.status,
            PostalCode: oneEx.postalCode,
            Paid: oneEx.paid,
            LastFourDigits: oneEx.lastFourDigits,
            OrderDate: moment(oneEx.createdDate).format('ddd MMM DD YYYY HH:mm'),
            PickUpDate: oneEx.pickUpDate,
            PickUpTime: oneEx.pickUpTime,
            Total: oneEx.total,
            DriveThroughPickUp: oneEx.driveThroughPickUp,
            PreferredDeliveryTime: oneEx.preferredDeliveryTime,
            CurbSidePickUp: oneEx.curbSidePickUp,
            ForShipping: oneEx.forShipping,
            Products: oneEx.products.map(p => {
                return {
                    ProductName: p.product,
                    Quantity: p.quantity,
                    Location: p.location,
                    SKU: p.sku, 
                };
            }),
        };
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: "PRINT EXPRESSCHECKOUT",
                Data: JSON.stringify(data)
            };
            this.ws.send(JSON.stringify(model));
        }
        else if (this.props.padVersion) {
            const model = {
                Command: "PRINT EXPRESSCHECKOUT",
                Data: data
            };
            expressCheckoutPrinting(JSON.stringify(model));
        }
    }

    stopLoading = () => {
        this.setState({
            loading: false
        });
        clearInterval(this.getUnprintedOrdersInterval);
        clearInterval(this.refreshPageInterval);
        this.refreshPageInterval = setInterval(() => {
            this.getAllOnlineOrders();
        }, 1000 * 60);
    }

    initWebSocket = () => {
        try {
            console.log('i want to init web socket');
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    console.log('ws connected');
                }
            };

            this.ws.onerror = () => {
                console.log('error when init web socket');
            };

            this.ws.onclose = (event) => {

                if (event.code !== 99999) {
                    console.log("Websocket is Locked!");
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(1000);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(`ERROR ON INIT FUNCTION CATCH: ${err}`);
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getPagedOnlineOrder
        );
    }

    getPagedOnlineOrder = () => {
        this.props.getOnlineOrder({
            branchId: this.props.branchId,
            activePage: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            orderCode: 0,
            onlineOrderStatus: this.props.onlineOrderStatus,
            onlineOrderType: this.props.onlineOrderType,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            phone: this.props.phone,
            email: this.props.email,
            beginDate: this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : "",
            endDate: this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : ""
        });
        this.props.clearFormInput("OnlineOrderListOrderCode");
    }

    search = () => {
        this.props.getOnlineOrder({
            branchId: this.props.branchId,
            activePage: 1,
            itemsPerPage: 15,
            orderCode: this.props.OnlineOrderListOrderCode,
            onlineOrderStatus: this.props.onlineOrderStatus,
            onlineOrderType: this.props.onlineOrderType,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            phone: this.props.phone,
            email: this.props.email,
            beginDate: this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : "",
            endDate: this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : ""
        });
    }

    openDialogUnprintedOrder = () => {
        this.setState({ ...this.state, dialogClearUnprintedOrders: true })
    }

    closeDialogUnprintedOrders = () => {
        this.setState({ ...this.state, dialogClearUnprintedOrders: false })
    }

    clearUnprintedOrders = () => {
        this.props.clearUnprintedOrders(this.props.branchId)
        this.closeDialogUnprintedOrders()
    }

    render() {
        const list = (this.props.onlineOrdersList !== null && this.props.onlineOrdersList !== undefined) ? this.props.onlineOrdersList : [];

        const ordersList = (list.length > 0) ?
            list.map((item) => {

                let itemStatus = LOOKUP.ecommerce.onlineOrders.orderStatus.filter(i => i.value == item.status);
                let itemType = LOOKUP.ecommerce.onlineOrders.orderType.filter(i => i.value == item.type);

                return {
                    OrderNumber: (<Link to={`/ecommerce/online-orders/details/${item.id}`}> {item.code || item.buddiNumber} </Link>),
                    CreatedOn: moment(item.createdDate).format('MMMM Do, YYYY HH:mm'),
                    Type: itemType !== null &&
                        itemType !== undefined &&
                        itemType.length > 0
                        ? `${itemType[0].text}${item.deliveryMethod ? ` - ${item.deliveryMethod}` : ''}`
                        : '',
                    Total: '$ ' + item.total.toFixed(2),
                    Status: <div className="d-flex">
                        <span className={"status-online-order status-" + item.status}>
                            {(itemStatus !== null && itemStatus !== undefined && itemStatus.length > 0) && itemStatus[0].text}
                        </span>
                        {(item.paid) && <span className="status-online-order status-3">Paid</span>}
                    </div>,
                    Tips: '$ ' + item.tips.toFixed(2),
                    DeliveryFee: '$ ' + item.deliveryFee.toFixed(2),
                    Options: <div className="d-flex"><Button type="IconViewButton" onTouchTap={() => this.showOnlineOrder(item.id)} />
                        <Button className="PrintButtonClass" type="PrintButton" onTouchTap={() => this.printOrder(item.id)} /></div>
                }
            })
            : [];

        return (
            <Grid headerContent={onlineOrdersCrumb}>
                <PageHeaderWithButton title={LOOKUP.ecommerce.onlineOrders.title}>
                    <Button
                        mini={true}
                        className="bg-light-green mr-2"
                        label="Detect New Orders"
                        onTouchTap={() => this.getUnPrintedOrders()}
                    />
                    <Button
                        mini={true}
                        className="bg-light-green"
                        label="Clear Unprinted Orders"
                        onTouchTap={() => this.openDialogUnprintedOrder()}
                    />
                </PageHeaderWithButton>
                <SearchFields pageName={pageName}
                    search={this.search}
                />
                <DialogInput
                    modal={true}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogUnprintedOrders()}
                        />,
                        <Button
                            key={3}
                            type="SaveButtonNoIcon"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={"Clear"}
                            onTouchTap={() => this.clearUnprintedOrders()}
                        />
                    ]}
                    open={this.state.dialogClearUnprintedOrders}
                    title={<DialogHeaderWithClose text="Clear Unprinted Orders" classicClass="posDialogClassic" handleClose={() => this.closeDialogUnprintedOrders()} />}
                >
                    <p>Do you want to clear the unprinted order list?</p>
                </DialogInput>
                <Dialog
                    modal={true}
                    open={this.state.loading}
                    contentStyle={loadDialogcustomContentStyle}
                    style={loadDialogStyle}>
                    <div className="loading">
                        <CircularProgress size={50} thickness={5} />
                        <br />
                        <h4 className="text-center purpleText">Catching Orders</h4>
                        <div className="pospaymentLoadingProblemBtn"
                            onClick={() => this.stopLoading()}
                        >
                            Stop
                        </div>
                    </div>
                </Dialog>
                <br />
                <CardSimple title="All Orders" className="paddingForMobileDevicesNoDiv cardTitleSpace pa-1">
                    <div className="form-group">
                        <GenericTable
                            className="table_center tableHeaderwhiteColorFont"
                            tableBodyClassName="onlineorder-table"
                            multiSelectable={false}
                            enableSelectAll={false}
                            selectable={false}
                            columns={LOOKUP.ecommerce.onlineOrders.listTableColumnsAdd}
                            rows={ordersList}
                            stripedRows={true}
                        />
                        <Pagination
                            length={this.props.onlineOrderTotal || 0}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </div>
                </CardSimple>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        onlineOrdersList: state.entity.onlineOrder,
        branchId: state.common.branchId,
        saveSuccess: state.form.homeSettingSaveSuccess,
        saveError: state.form.homeSettingSaveSuccessSaveError,
        isMedical: state.common.applicationSettings.isMedical,
        padVersion: state.common.applicationSettings.padVersion,
        store: state.common.store,
        printingServerInterval: state.common.applicationSettings.printingServerInterval,
        onlineOrderTotal: state.entity.onlineOrderTotal,
        OnlineOrderListOrderCode: state.form.OnlineOrderListOrderCode || 0,
        onlineOrderStatus: state.form.OnlineOrderListStatus || 0,
        onlineOrderType: state.form.OnlineOrderListType || 0,
        unprintedOrdersSuccess: state.entity.unprintedOrdersSuccess,
        firstName: state.form["OnlineOrderListFirstName"] || "",
        lastName: state.form["OnlineOrderListLastName"] || "",
        email: state.form["OnlineOrderListEmail"] || "",
        phone: state.form["OnlineOrderListPhone"] || "",
        beginDate: state.form["OnlineOrderListbeginDate"] || "",
        endDate: state.form["OnlineOrderListendDate"] || ""

    }
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        getOnlineOrder: (model) => dispatch(getOnlineOrder(model)),
        clearUnprintedOrders: (branchId) => dispatch(clearUnprintedOrders(branchId)),
        getUnPrintedOrders: (branchId) => dispatch(getUnPrintedOrders(branchId)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(OnlineOrdersPage));
